var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comment"},[(_vm.tocontent)?_c('div',{staticClass:"origin"},[_vm._v(" "+_vm._s(_vm.tocontent)+" ")]):_vm._e(),_vm._v(" "+_vm._s(_vm.content)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }